function s4() {
    return Math.floor((Math.random() + 1) * 0x10000)
        .toString(16)
        .substring(1);
}

export function newGuid(): string {
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
}
